var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteNoteEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Note_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00015 3.5H5.90015C5.06007 3.5 4.63972 3.5 4.31885 3.66349C4.0366 3.8073 3.8073 4.0366 3.66349 4.31885C3.5 4.63972 3.5 5.06007 3.5 5.90015V13.1001C3.5 13.9402 3.5 14.36 3.66349 14.6809C3.8073 14.9632 4.0366 15.1929 4.31885 15.3367C4.6394 15.5 5.05925 15.5 5.89768 15.5H13.1023C13.9408 15.5 14.36 15.5 14.6805 15.3367C14.9628 15.1929 15.1929 14.9629 15.3367 14.6807C15.5 14.3601 15.5 13.9408 15.5 13.1023V11M12.5 4.25L8 8.75V11H10.25L14.75 6.5M12.5 4.25L14.75 2L17 4.25L14.75 6.5M12.5 4.25L14.75 6.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteNoteEditIcon);
export default __webpack_public_path__ + "static/media/white_note_edit_icon.b43872aa1a92ab8d80eb8d94769598a0.svg";
export { ForwardRef as ReactComponent };